module.exports = __webpack_public_path__ + "img/nina-balaban.112f7e51.jpg";